import { Flex } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import Roles from "./Roles";
import Permission from "./Permission";
import { getRoleDetail, getRoles } from "../../util/http";
import Loader from "../UI/Loader";
import { AuthContext } from "../../util/context";

export default function SettingCenter() {
  const ctx = useContext(AuthContext);
  const [roles, setRoles] = useState([]);
  const [permitted, setPermitted] = useState([]);
  const [notPermitted, setNotPermitted] = useState([]);
  const [users, setUsers] = useState([]);
  const [progress, setProgress] = useState(0);

  const [role, setRole] = useState("");

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await getRoles();

        setRoles(response.roles);
        setRole(response?.roles[0]);
      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      try {
        setProgress(20);
        setProgress(40);
        setProgress(60);
        const response = await getRoleDetail(role.toLowerCase());
        setProgress(80);
        setProgress(100);
        setUsers(response?.users);
        setPermitted(response?.permissions);
        setNotPermitted(response?.unassigned_permissions);
      } catch (error) {
        setProgress(100);
        console.log(error);
      }
    }
    fetchData();
  }, [role]);

  return (
    <>
      <Loader progress={progress} setProgress={setProgress} />
      <Flex align="center" w="100%" bg="white">
        <Roles roles={roles} setRole={setRole} role={role} />
        <Permission
          permitted={permitted}
          users={users}
          notPermitted={notPermitted}
        />
      </Flex>
    </>
  );
}
